import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=0226f454&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0226f454')) {
      api.createRecord('0226f454', component.options)
    } else {
      api.reload('0226f454', component.options)
    }
    module.hot.accept("./platform.vue?vue&type=template&id=0226f454&", function () {
      api.rerender('0226f454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/platform.vue"
export default component.exports